export default {"src":"/_next/static/media/Circle2.7e1357d0.svg","height":567,"width":570,"blurWidth":0,"blurHeight":0};